import React from 'react';
import { Provider } from "react-redux";
import ReactDOM from 'react-dom';

import store, { history } from "./store.jsx";

import {configure} from 'react-hotkeys';

import Application from 'pages/application';

import 'index.css';

import AuthInterceptor from './services/auth.interceptor.js';

import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@paperflite-marketing/cleverstory-commons/dist/index.css';

new AuthInterceptor(history);

configure({
  ignoreRepeatedEventsWhenKeyHeldDown: false,
  stopEventPropagationAfterHandling: false,
  stopEventPropagationAfterIgnoring: false
});


ReactDOM.render(
  <Provider store={store}>
    <Application />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
